import { FC } from 'react';
import { useLocation } from 'react-use';

import Icon from 'atoms/Icons/Icon';
import color from 'atoms/colors/colors';

import Flex from 'quarks/Flex';

import shareSocialLink from 'utils/shareSocialLink';
import UseSharePage from 'utils/useSharePage';

export type SocialShareProps = {
  title?: string | null;
};

const SocialShare: FC<SocialShareProps> = ({ title }) => {
  const { href } = useLocation();

  const icons = [
    { id: 'link-01', onClick: () => UseSharePage(href || '') },
    { id: 'twitter', onClick: () => shareSocialLink('twitter', title || '') },
    { id: 'facebook-round', onClick: () => shareSocialLink('facebook', title || '') },
    { id: 'linkedin-round', onClick: () => shareSocialLink('linkedin', title || '') },
  ];

  return (
    <Flex gap="12px">
      {icons.map(icon => (
        <Flex
          key={icon.id}
          paddingAll={8}
          backgroundColor="gray-50"
          borderRadius="8px"
          border="1px solid"
          borderColor="gray-200"
          hover={{ backgroundColor: 'green-300' }}
          cursor="pointer"
          onClick={icon.onClick}
        >
          <Icon id={icon.id} fill={color.gray[700]} size={20} />
        </Flex>
      ))}
    </Flex>
  );
};

export default SocialShare;

SocialShare.defaultProps = {
  title: '',
};
